import createRoute from '@widesk-ui/tools/createRoute';
import TagModel    from '@models/shop/TagModel';

export default createRoute.splitView('/tags', 'shop', 'TagSplitView', TagModel.localize('plural'));